<template>
  <div class="down-load-wrap"  v-if="hostname === 'www.xesmall.com'">
    <div class="down-load">
      <div class="logo">
        <img src="https://editor.xesimg.com/tailor/resource/image3-1772784524244.png" alt="" />
      </div>
      <div class="qr-code-wrap">
        <div class="qr-code-select">
          <div class="qr-code-select-item iphone" @click="onChange('iphone')" :class="{ active: select === 'iphone' }">
            <img
              class="icon"
              :src="
                select === 'iphone'
                  ? 'https://editor.xesimg.com/tailor/resource/icon4-1663569885247.png'
                  : 'https://editor.xesimg.com/tailor/resource/icon3-1663569885246.png'
              "
            />
            <div class="item-label">iPhone/iPad客户端</div>
          </div>

          <div
            class="qr-code-select-item android"
            @click="onChange('android')"
            :class="{ active: select === 'android' }"
          >
            <img
              class="icon"
              :src="
                select === 'android'
                  ? 'https://editor.xesimg.com/tailor/resource/icon2-1663569885246.png'
                  : 'https://editor.xesimg.com/tailor/resource/icon1-1663569885245.png'
              "
            />
            <div class="item-label">Android 客户端</div>
          </div>
        </div>
        <div class="qr-code-intro">
          <div class="qr-code-img">
            <img :src="appInfo[select].qrCodeImg" />
          </div>
          <div class="qr-code-info">
            <div class="title">{{ appInfo[select].title }}</div>
            <div class="version">版本：{{ appInfo[select].version }}</div>
            <div class="content">
              {{ appInfo[select].content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { reactive, ref } from 'vue';
const hostname = ref(window.location.hostname);
const select = ref('iphone');
const appInfo = reactive({
  iphone: {
    title: 'iOS客户端',
    version: '10.16.10',
    content:
      '设备支持：iOS13及以上系统版本；以下设备支持，但可能会影响上课体验：iPhone6/Plus、iPhone6s/Plus、iPhone7/Plus iPad4、iPad Air、iPad Air2、iPad mini、iPad mini3、iPad mini4',
    qrCodeImg: 'https://editor.xesimg.com/tailor/resource/ios-1717668672763.png',
  },
  android: {
    title: 'Android客户端',
    version: '10.16.03',
    content: '设备支持：Android 6.0以上系统版本，2GB及以上运行内存',
    qrCodeImg: 'https://editor.xesimg.com/tailor/resource/code-1772784524244.png',
  },
});

const onChange = (value) => {
  select.value = value;
};
</script>

<style lang="scss" scoped>
.down-load-wrap {
  background: #fbf9f9;
  .down-load {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    height: 406px;
    align-items: center;
    justify-content: space-between;
    .logo {
      width: 138px;
      margin-right: 64px;
      img {
        width: 100%;
      }
    }
    .qr-code-wrap {
      display: flex;
      align-items: center;
      flex: 1;
      .qr-code-select {
        margin-right: 33px;
        .qr-code-select-item {
          width: 259px;
          height: 62px;
          background: #fff;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding: 10px 14px;
          border-radius: 10px;
          margin-bottom: 14px;
          cursor: pointer;
          &.android {
            margin-bottom: 0;
          }
          .icon {
            width: 41px;
            height: 41px;
            margin-right: 15px;
          }
          .item-label {
            font-size: 17px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #565758;
            line-height: 24px;
          }

          &.active {
            background: url('https://editor.xesimg.com/tailor/resource/select-1663569746737.png') no-repeat;
            background-size: contain;
            .item-label {
              font-size: 17px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #e02727;
              line-height: 24px;
            }
          }
        }
      }
      .qr-code-intro {
        height: 165px;
        background: #ffeeee;
        box-sizing: border-box;
        padding: 20px 10px;
        display: flex;
        flex: 1;
        .qr-code-img {
          width: 135px;
          height: 135px;
          flex-shrink: 0;
          img {
            width: 100%;
          }
        }
        .qr-code-info {
          .title {
            font-size: 21px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #3c3939;
            line-height: 31px;
            margin-bottom: 9px;
          }
          .version {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 13px;
            margin-bottom: 23px;
          }
          .content {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
          }
        }
      }
    }
  }
}
</style>
